<template>
	<v-row justify="center">
		<v-dialog v-model="dialog" persistent scrollable max-width="550" content-class="rounded-lg" @keydown.esc="dialog = false">
			<v-card>
				<v-card-title class="h6">
					<span class="primary--text text-uppercase font-size-16 font-weight-bold">Opsi Pengiriman</span>
					<v-spacer></v-spacer>
					<v-btn text small color="pink" class="mr-n4" @click="modalHide">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text class="pb-0" v-if="!loading">
					<div class="py-2"><v-divider></v-divider></div>
					<v-row align="center" justify="center">
						<v-col cols="12" v-if="Object.keys(courier).length > 0">
							<div class="text-body-1 font-weight-bold pb-4">Jasa Kurir</div>
							<v-expansion-panels accordion  v-model="panel">
								<v-expansion-panel
									v-for="(group, idg) in Object.keys(courier)"
									:key="idg"
								>
									<v-expansion-panel-header class="text-capitalize py-1 px-2 primary--text font-weight-bold">{{ setcourierGroup(group) }}</v-expansion-panel-header>
									<v-expansion-panel-content>
										<v-radio-group class="mt-0" hide-details="auto" v-model="selectedCour">
											<div class="pa-2 border" :class="(courier[group].length > 1) ? 'mb-2' : ''" v-for="(cour, index) in courier[group]" :key="index">
												<v-radio :value="cour" class="small-check mt-0">
													<template slot="label">
														<v-row class="px-3 text-body-2 grey--text text--darken-3">
															<v-col sm="6" md="6" class="py-0 my-auto d-flex">
																<v-img height="50" width="auto" contain position="left center" :src="cour.logistic_logo_url"></v-img>
															</v-col>
															<v-col sm="6" md="6" class="py-0 my-auto d-flex flex-column text-right">
																<span class="d-block mb-1 font-weight-bold">{{cour.logistic_name}} - {{cour.rate_name}}</span>
																<span class="d-block mb-1">{{(cour.min_duration == cour.max_duration) ? cour.min_duration + ((cour.duration_type == 'DAY') ? ' hari' : ' jam') : cour.min_duration + ' - ' + cour.max_duration + ((cour.duration_type == 'DAY') ? ' hari' : ' jam')}}</span>
																<span class="d-block">Rp {{cour.price | toNumber}}</span>
															</v-col>
														</v-row>
													</template>
												</v-radio>
											</div>
										</v-radio-group>
									</v-expansion-panel-content>
								</v-expansion-panel>
							</v-expansion-panels>

						</v-col>
						<v-col cols="12" v-else>
							<div class="text-body-1 font-weight-bold pb-1">Jasa Kurir</div>
							<div class="text-center pa-5">Mohon maaf saat ini tidak ada kurir yang tersedia</div>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-text class="py-8" v-else>
					sedang memuat data...
				</v-card-text>
				<v-card-actions class="pt-0 mb-4">
					<v-spacer></v-spacer>
					<template v-if="Object.keys(courier).length > 0">
						<v-btn 
							depressed
							color="primary"
							height="45"
							width="150"
							class="text-capitalize font-weight-bold rounded-lg"
							:disabled="(Object.keys(selectedCour).length > 0) ? false : true"
							@click="pilihCour"
						>Pilih</v-btn>
						<v-btn @click="closeModal" outlined color="primary" depressed class="text-capitalize font-weight-bold rounded-lg" height="45" width="150">Batal</v-btn>
					</template>
					<template v-else>
						<v-btn @click="closeModal" outlined color="primary" depressed class="text-capitalize font-weight-bold rounded-lg" height="45" width="150">Tutup</v-btn>
					</template>
					<v-spacer></v-spacer>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
// import { mapState } from 'vuex'

export default {
	data () {
		return {
			selectedCour: {},
			dialog: false,
			panel: 0
		}
	},
	props: {
		courier: Object,
		loading: Boolean
	},
	computed: {
	},
	methods: {
		modalShow() {
			this.dialog = true
		},
		modalHide() {
			this.dialog = false
		},
		closeModal() {
			this.selectedCour = {}
			this.modalHide()
		},
		pilihCour() {
			this.$emit('action', this.selectedCour)
			this.modalHide()
		},
		setcourierGroup(group) {
			let textgroup = group.replaceAll('_', ' ')
			return textgroup
		}
	}
};
</script>